import { HttpClient } from '../../httpClient'
import { queryString } from '../../httpClient/queryString'
import type { OpalApi } from '../../schema'

type ReadViewStandardColumns = OpalApi<'ReadViewStandardColumnsV3', 200>

export const readViewStandardColumns: ReadViewStandardColumns = async ({
  params,
}: Parameters<ReadViewStandardColumns>[0] = {}) => {
  const url = new URL('/loupe/v3/view_standard_columns', window.location.origin)

  url.search = queryString(params?.query)

  return HttpClient()
    .get(url.toString())
    .then((res) => res.data)
}
